import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_network_interface.js";
//#region src/kiosk_network_interface_helper.ts
var kiosk_network_interface_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(networkInterface) {
	switch (networkInterface) {
		case 0: return "N/A";
		case 1: return "WiFi";
		case 2: return "Ethernet";
	}
}
//#endregion
export { kiosk_network_interface_helper_exports, stringFromEnum };

//# sourceMappingURL=kiosk_network_interface_helper.js.map